// @flow
import _ from 'lodash';

import type { TRootStore } from '../../types';

export const getWaiversFree = (
	state: TRootStore
) => _.get(state, 'leagues.waiver_free.ordered_ids', []);

export default getWaiversFree;


// WEBPACK FOOTER //
// ./src/modules/selectors/league/getWaiversFree.js